import { ModalTypes, InfoModal, SuccessModal, IInfoModalProps, ISuccessModalProps, ModalLoader } from './components';
import { IConfirmationModalProps } from './IConfirmationModal';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { useState, useEffect } from 'react';
import * as S from './ConfirmationModal.styled';

enum ConfirmationModalSteps {
  PRIMARY_CONFIRMATION = 1,
  SECONDARY_CONFIRMATION = 2,
  OPERATION_RESULT = 3,
  LOADING_CONFIRMATION = 4,
}

export const ConfirmationModal = (props: IConfirmationModalProps): JSX.Element => {
  const [currentStep, updateStep] = useState<ConfirmationModalSteps>(ConfirmationModalSteps.PRIMARY_CONFIRMATION);
  const {
    modalType,
    primaryConfirmation,
    subTitle,
    secondaryConfirmation,
    confirmButtonText,
    cancelButtonText,
    operationSuccessMessage,
    onConfirm,
    onClose,
    showSuccessModal,
    onSuccessModalClose,
    onCrossBtnClick,
    showModalHeader,
    modalTitle,
    customStyle,
    icon,
    iconColor,
  } = props;

  useEffect(() => {
    if (showSuccessModal) {
      updateStep(ConfirmationModalSteps.OPERATION_RESULT);
      setTimeout(() => {
        onClose();
        onSuccessModalClose?.();
      }, 3000);
    }
  }, [showSuccessModal]);

  const handleSecondaryConfirmation = () => {
    onConfirm();
    updateStep(ConfirmationModalSteps.LOADING_CONFIRMATION);
  };

  const handlePrimaryConfirmation = () => {
    handleSecondaryConfirmation();
  };

  const primaryInfoModalArgs: IInfoModalProps = {
    modalType: modalType,
    icon: icon || <CheckCircleOutlineIcon />,
    iconColor,
    title: primaryConfirmation,
    subTitle: subTitle,
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    onConfirm: handlePrimaryConfirmation,
    onClose: onClose,
    onCrossBtnClick,
    showModalHeader,
    modalTitle,
    customStyle,
  };

  const secondaryInfoModalArgs: IInfoModalProps = {
    modalType: modalType,
    icon: icon || <DeleteOutlineOutlinedIcon />,
    iconColor,
    title: secondaryConfirmation || '',
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    onConfirm: handleSecondaryConfirmation,
    onClose: onClose,
  };

  const successModalArgs: ISuccessModalProps = {
    icon: icon || <CheckCircleOutlineOutlinedIcon />,
    heading: 'Congratulations',
    message: operationSuccessMessage || '',
    operationType: modalType,
  };
  if (modalType === ModalTypes.Danger) {
    primaryInfoModalArgs.icon = <InfoOutlinedIcon />;
    successModalArgs.heading = 'Deleted';
  }

  const renderConfirmationModal = () => {
    switch (currentStep) {
      case ConfirmationModalSteps.PRIMARY_CONFIRMATION:
        return <InfoModal {...primaryInfoModalArgs} />;
      case ConfirmationModalSteps.LOADING_CONFIRMATION:
        return <ModalLoader type={modalType as ModalTypes} />;
      case ConfirmationModalSteps.SECONDARY_CONFIRMATION:
        return <InfoModal {...secondaryInfoModalArgs} />;
      case ConfirmationModalSteps.OPERATION_RESULT:
        return <SuccessModal {...successModalArgs} />;
      default:
        return <InfoModal {...primaryInfoModalArgs} />;
    }
  };

  return <S.ConfirmationModalWrapper>{renderConfirmationModal()}</S.ConfirmationModalWrapper>;
};
